import React, { Fragment, useCallback, useState, useEffect } from 'react';
import classnames from 'classnames';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    TabbedForm,
    FormTab, EditButton,
    Edit, SimpleForm, TextInput, TextField,
    ReferenceInput, SelectInput,
    ReferenceManyField, Datagrid, NumberField, RichTextField, BooleanField,
    DateInput, BooleanInput, NumberInput, ImageInput, ImageField, FormDataConsumer, Button
} from 'react-admin';
import { useStyles } from "../../formStyles";
import RichTextInput from 'ra-input-rich-text';
import AddQuestionOptionButton from './AddQuestionOptionButton';
import EditQuestionOptionButton from "./EditQuestionOptionButton";
import { Route, useHistory } from 'react-router-dom';
import { Drawer, useMediaQuery, makeStyles } from '@material-ui/core';
import { parse } from "query-string";
import CustomLogoInputDisplay from "../../CustomImage";
import { CreateToolbar } from "../../CreateToolbar";
import * as apiClient from "../../apiClient";
const useMyStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    list: {
        flexGrow: 1,
        transition: theme.transitions.create(['all'], {
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: 0,
    },
    listWithDrawer: {
        marginRight: 300,
    },
    drawerPaper: {
        zIndex: 100,
        marginTop: 50,
        width: 350,
    },
}));
export const QuestionEdit = props => {
    const formClasses = useStyles({});
    const classes = useMyStyles({});
    const [isLoadingTest, setIsLoadingTest] = useState(true);
    const [testDetails, setTestDetails] = useState(null);

    const { test_id: test_id_string } = parse(props.location.search);
    const test_id = test_id_string ? parseInt(test_id_string, 10) : "";



    const GetTestDetail = () => {
        setIsLoadingTest(true)
        apiClient.getData(`/tests/${test_id}`).then((response) => {
            setIsLoadingTest(false);
            setTestDetails(response[0])
        });
    }
    useEffect(() => {
        GetTestDetail();
    }, [test_id]);
    return (
        <Edit {...props} title="Edit question">
            <TabbedForm redirect={false} toolbar={<CreateToolbar {...props} />} variant="outlined">
                <FormTab label="Question">
                    <ReferenceInput label="Test" disabled validate={required()} source="testId" reference="tests" fullWidth={true} formClassName={formClasses.first_inline_input}>
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <ReferenceInput label="Subject" validate={required()} source="subjectId" reference="subjects" fullWidth={true} formClassName={formClasses.last_inline_input}>
                        <SelectInput optionText="name" />
                    </ReferenceInput>
                    <ReferenceInput label="Question Type" validate={required()} source="questionTypeId" reference="questiontypes" fullWidth={true} formClassName={formClasses.one_three_input}>
                        <SelectInput optionText="questionTypeName" />
                    </ReferenceInput>

                    <NumberInput source="noOfChoice" validate={required()} label="No of Choices" fullWidth={true} formClassName={formClasses.two_three_input} />
                    <NumberInput source="questionNumber" validate={required()} label="Question Number" fullWidth={true} formClassName={formClasses.last_three_input} />
                    <ReferenceInput label="Section Type" fullWidth={true}
                        perPage={5000} source="sectionTypeId"
                        reference="statuses"
                        filter={{ statusType: 'Sections' }}
                        sort={{ field: 'status', order: 'ASC' }}
                        validate={required()} formClassName={classes.one_three_input}
                    >
                        <SelectInput optionText="status" variant="outlined" validate={[required()]} />
                    </ReferenceInput>
                    <ReferenceInput label="Scoring Type" fullWidth={true}
                        perPage={5000} source="scoringTypeId"
                        reference="scoring-types"
                        sort={{ field: 'name', order: 'ASC' }}
                        validate={required()} formClassName={classes.two_three_input}
                    >
                        <SelectInput optionText="name" variant="outlined" validate={[required()]} />
                    </ReferenceInput>
                    <RichTextInput source="instructions" label="Instructions" />
                    <ImageInput source="instructionUrl" label="Instruction" accept="image/*" className="logourl">
                        <ImageField source="instructionUrl" title="Icon" />
                    </ImageInput>
                    <CustomLogoInputDisplay field="instructionUrl" />

                    <NumberInput source="totalMarks" label="Total Marks" validate={required()} fullWidth={true} formClassName={classes.one_three_input} />
                    <NumberInput source="totalTime" label="Total Time" validate={required()} fullWidth={true} formClassName={classes.two_three_input} />
                    <RichTextInput source="question" label="Question" />
                    <ImageInput source="logoUrl" label="Icon" accept="image/*" className="logourl">
                        <ImageField source="logoUrl" title="Icon" />
                    </ImageInput>
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            formData.logoUrl ? ( // Check if an image is uploaded
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <ImageField source="logoUrl" title="Icon" {...rest} />
                                    <Button
                                        label="Remove"
                                        onClick={() => {
                                            formData.logoUrl = null; // Remove the image
                                            rest.form.setState({ values: { ...formData } }); // Update form state
                                        }}
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            right: 0,
                                            backgroundColor: "red",
                                            color: "white",
                                            minWidth: "30px",
                                        }}
                                    >

                                    </Button>
                                </div>
                            ) : (
                                <ImageInput source="logoUrl" label="Icon" accept="image/*">
                                    <ImageField source="logoUrl" title="Icon" />
                                </ImageInput>
                            )
                        }
                    </FormDataConsumer>

                    <BooleanInput initialValue={true} validate={required()} source="mustAnswer" label="Must Answer" />
                </FormTab>
                <FormTab label="Question Options">
                    <AddQuestionOptionButton />
                    <ReferenceManyField perPage={100} reference="testquestionoptions" target="testQuestionId" addLabel={false} fullWidth={true}>
                        <Datagrid>
                            <EditQuestionOptionButton />
                            <NumberField source="optionNumber" label="Option Number" />
                            <TextField source="optionTitle" label="Option Title" />
                            <RichTextField source="optionText" label="Option Text" />
                            <ImageField source="optionImage" label="Option Image" />
                            <BooleanField source="isCorrect" label="Is Correct" />
                        </Datagrid>
                    </ReferenceManyField>

                </FormTab>
            </TabbedForm>
        </Edit>
    );
}